import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AccountService } from 'src/app/shared/services/account.service';


@Component({
    templateUrl: './login.component.html'
})

export class LoginComponent implements OnInit {
    loginForm: FormGroup = this.formBuilder.group({
        userName: ['', [Validators.required, Validators.email]],
        password: ['', [Validators.required]],
    });;
    recoverform = false;
    submitted = false;
    returnUrl: string;
    loading = false;
    isexist: any;
    isLoginWithSharedLink: boolean = false;

    constructor(private formBuilder: FormBuilder,
        private _accountServices: AccountService,
        private router: Router,
        private route: ActivatedRoute,
        private alert: ToastrService) {
        const loginObjectString = this.route.snapshot.queryParams['accesskey'];
        if (loginObjectString) {
            let loginObj;
            try {
                loginObj = JSON.parse(atob(loginObjectString));
            }
            catch {
                loginObj = null;
                this.alert.error('Invalid URL', 'Error')
            }

            if (loginObj && loginObj.userName && loginObj.password) {
                this.loginForm.patchValue({
                    userName: loginObj.userName,
                    password: loginObj.password,
                })
                this.onSubmit();
                this.isLoginWithSharedLink = true;
            }
        }

        if (this._accountServices.currentUserValue.emailId) {
            this.router.navigate(['/dashboard/home']);
        }
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard/home'
    }

    ngOnInit(): void {
    }

    get f() { return this.loginForm.controls; }

    onSubmit() {
        this.submitted = true;
        if (this.loginForm.invalid) {
            return;
        }
        const email = this.loginForm.value.userName;
        this.loading = true;
        this._accountServices.checkUserExist(email).subscribe((exist) => {
            this.isexist = exist.data
            if (this.isexist == true) {
                const loginDetail = {
                    email: email,
                    password: this.loginForm.value.password
                };
                this._accountServices.postUserLogin(loginDetail).subscribe(
                    (data: any) => {
                        this.redirectUser(data);
                    },
                    (error: any) => {
                        this.loading = false;
                        this.alert.error('Username or password is incorrect');
                    },
                    () => {
                        setTimeout(() => {
                            this.loading = false;
                        }, 5000);
                    }
                );
            } else {
                this.loading = false;
                this.alert.error('Email is not registered. Please register first.');
            }
        });
    }

    forgetPassword() {
        this.router.navigate(['/authentication/forget-password']);
    }

    signUp() {
        this.router.navigate(['/authentication/signup']);
    }

    redirectUser(data: any) {
        if (data) {
            const url = this.router.serializeUrl(this.router.createUrlTree(['/dashboard/home']));
            window.open('#' + url, '_self');
            location.reload();
        }
        else {
            const message = `Email ${this.f.userName.value} does not exists in our database`//`Invalid username or password`;
            this.alert.error(message, 'error');
        }

    }
}    